import { TMediaBreakpoints, TMediaQueries } from './types'

export const MediaQueries: TMediaQueries = {
  xs: '<576px',
  sm: '>=576px',
  md: '>=768px',
  lg: '>=992px',
  xl: '>=1200px',
}

export const MediaBreakpoints: TMediaBreakpoints = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
}
